import { gql } from "apollo-angular";
import {
    CART_FRAGMENT,
    ERROR_RESULT_FRAGMENT,
} from "../../../common/graphql/fragments.graphql";

export const GET_ELIGIBLE_PAYMENT_METHODS = gql`
    query GetEligiblePaymentMethods {
        eligiblePaymentMethods {
            id
            code
            name
            description
            eligibilityMessage
            isEligible
        }
    }
`;

export const GET_STRIPE_PUBLISHABLE_KEY = gql`
    query GetStripePublishableKey {
        stripePublishableKey
    }
`;

export const GET_STRIPE_SURCHARGE_PERCENT = gql`
    query GetStripeSurchargePercent {
        stripeSurchargePercent
    }
`;

export const GET_ELIGIBLE_SHIPPING_METHODS = gql`
    query GetEligibleShippingMethods {
        eligibleShippingMethods {
            id
            code
            name
            description
            price
            priceWithTax
        }
    }
`;

export const SET_SHIPPING_ADDRESS = gql`
    mutation SetShippingAddress($input: CreateAddressInput!) {
        setShippingAddressForOrder(input: $input) {
            id
        }
    }
`;

export const SET_BILLING_ADDRESS = gql`
    mutation SetBillingAddress($input: CreateAddressInput!) {
        setOrderBillingAddress(input: $input) {
            ...Cart
            ...ErrorResult
        }
    }
    ${CART_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const SET_SHIPPING_METHOD = gql`
    mutation SetShippingMethod($shippingMethodId: ID!) {
        assignShippingMethodToOrder(shippingMethodId: $shippingMethodId) {
            id
            totalWithTax
            shippingWithTax
            state
        }
    }
`;

export const TRANSITION_TO_ARRANGING_PAYMENT = gql`
    mutation TransitionToArrangingPayment {
        transitionOrderToState(state: "ArrangingPayment") {
            ...on Order {
                id
                state
            }
            ...ErrorResult
        }
    }
    ${ERROR_RESULT_FRAGMENT}
`;

export const TRANSITION_TO_ADDING_ITEMS = gql`
    mutation TransitionToAddingItems {
        transitionOrderToState(state: "AddingItems") {
            ...on Order {
                id
                state
            }
            ...ErrorResult
        }
    }
    ${ERROR_RESULT_FRAGMENT}
`;

export const ADD_PAYMENT = gql`
    mutation AddPayment($input: PaymentInput!) {
        addPaymentToOrder(input: $input) {
            ...on Order {
                id
                state
                code
            }
            ...ErrorResult
        }
    }
    ${ERROR_RESULT_FRAGMENT}
`;

export const CREATE_STRIPE_PAYMENT_INTENT = gql`
    mutation CheckoutGetPaymentIntent {
        createStripePaymentIntent
    }
`;

export const GET_ACTIVE_ORDER = gql`
    query GetActiveOrder {
        activeOrder {
            ...Cart
            customer {
                id
                firstName
                lastName
                emailAddress
            }
        }
    }
    ${CART_FRAGMENT}
`;
